// src/services/exerciseService.js
import { allExercises } from "../data/exercises";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase-config";

/** Collator dùng chung để so sánh chuỗi đa ngôn ngữ theo thứ tự tự nhiên */
const coll = new Intl.Collator(["vi", "ja", "en"], {
  numeric: true,
  sensitivity: "base",
});
const cmp = (a = "", b = "") => coll.compare(String(a), String(b));

/* ------------------------------------------------------------------ */
/* DỮ LIỆU GIẢ LẬP (mock)                                             */
/* ------------------------------------------------------------------ */
const mockData = {
  level1: {
    title: "簿記 3級",
    chapters: {
      chapter1: {
        title: "簿記 3級 第217回",
        exercises: [
          { id: "L1-01", title: "簿記 3級 第217-1回", status: "未完成" },
          { id: "L1-02", title: "簿記 3級 第217-2回", status: "未完成" },
          { id: "L1-03", title: "簿記 3級 第217-3回", status: "未完成" },
          { id: "L1-04", title: "簿記 3級 第217-4回", status: "未完成" },
          { id: "L1-05", title: "簿記 3級 第217-5回", status: "未完成" },
          { id: "L1-06", title: "簿記 3級 第217-6回", status: "未完成" },
          { id: "L1-07", title: "簿記 3級 第217-7回", status: "未完成" },
        ],
      },
      chapter2: {
        title: "簿記 3級 第218回",
        exercises: [
          { id: "L2-01", title: "簿記 3級 第218-1回", status: "未完成" },
          { id: "L2-02", title: "簿記 3級 第218-2回", status: "未完成" },
          { id: "L2-03", title: "簿記 3級 第218-3回", status: "未完成" },
          { id: "L2-04", title: "簿記 3級 第218-4回", status: "未完成" },
          { id: "L2-05", title: "簿記 3級 第218-5回", status: "未完成" },
          { id: "L2-06", title: "簿記 3級 第218-6回", status: "未完成" },
          { id: "L2-07", title: "簿記 3級 第218-7回", status: "未完成" },
        ],
      },
      chapter3: {
        title: "簿記 3級 第219回",
        exercises: [
          { id: "L3-01", title: "簿記 3級 第219-1回", status: "未完成" },
          { id: "L3-02", title: "簿記 3級 第219-2回", status: "未完成" },
          { id: "L3-03", title: "簿記 3級 第219-3回", status: "未完成" },
          { id: "L3-04", title: "簿記 3級 第219-4回", status: "未完成" },
          { id: "L3-05", title: "簿記 3級 第219-5回", status: "未完成" },
          { id: "L3-06", title: "簿記 3級 第219-6回", status: "未完成" },
          { id: "L3-07", title: "簿記 3級 第219-7回", status: "未完成" },
        ],
      },
      chapter4: {
        title: "簿記 3級 第212回",
        exercises: [
          { id: "L4-01", title: "簿記 3級 第212-1回", status: "未完成" },
          { id: "L4-02", title: "簿記 3級 第212-2回", status: "未完成" },
          { id: "L4-03", title: "簿記 3級 第212-3回", status: "未完成" },
          { id: "L4-04", title: "簿記 3級 第212-4回", status: "未完成" },
          { id: "L4-05", title: "簿記 3級 第212-5回", status: "未完成" },
          { id: "L4-06", title: "簿記 3級 第212-6回", status: "未完成" },
          { id: "L4-07", title: "簿記 3級 第212-7回", status: "未完成" },
        ],
      },
      chapter5: {
        title: "簿記 3級 第214回",
        exercises: [
          { id: "L5-01", title: "簿記 3級 第214-1回", status: "未完成" },
          { id: "L5-02", title: "簿記 3級 第214-2回", status: "未完成" },
          { id: "L5-03", title: "簿記 3級 第214-3回", status: "未完成" },
          { id: "L5-04", title: "簿記 3級 第214-4回", status: "未完成" },
          { id: "L5-05", title: "簿記 3級 第214-5回", status: "未完成" },
          { id: "L5-06", title: "簿記 3級 第214-6回", status: "未完成" },
          { id: "L5-07", title: "簿記 3級 第214-7回", status: "未完成" },
        ],
      },
      chapter6: {
        title: "簿記 3級 第215回",
        exercises: [
          { id: "L6-01", title: "簿記 3級 第215-1回", status: "未完成" },
          { id: "L6-02", title: "簿記 3級 第215-2回", status: "未完成" },
          { id: "L6-03", title: "簿記 3級 第215-3回", status: "未完成" },
          { id: "L6-04", title: "簿記 3級 第215-4回", status: "未完成" },
          { id: "L6-05", title: "簿記 3級 第215-5回", status: "未完成" },
          { id: "L6-06", title: "簿記 3級 第215-6回", status: "未完成" },
          { id: "L6-07", title: "簿記 3級 第215-7回", status: "未完成" },
        ],
      },
    },
  },
  level2: {
    title: "Level 2",
    chapters: {
      chapter1: {
        title: "Chapter 1: Kế toán Nâng cao",
        exercises: [],
      },
    },
  },
  level3: {
    title: "Level 3",
    chapters: {
      chapter1: {
        title: "Chapter 1: Kế toán Quản trị",
        exercises: [],
      },
    },
  },
};

/* ------------------------------------------------------------------ */
/* HÀM TRẢ VỀ DANH SÁCH LEVEL (SẮP XẾP THEO TITLE CỦA LEVEL)          */
/* ------------------------------------------------------------------ */
/**
 * Trả về mảng các level đã sort theo title A→Z.
 * Mỗi phần tử: { id: 'level1', title: '...', chapters: {...} }
 */
export const getLevelsSorted = () => {
  return Object.entries(mockData)
    .map(([id, data]) => ({ id, ...data }))
    .sort((a, b) => {
      // ưu tiên title; nếu thiếu title thì so theo id
      const byTitle = cmp(a.title, b.title);
      return byTitle !== 0 ? byTitle : cmp(a.id, b.id);
    });
};

/* ------------------------------------------------------------------ */
/* CHAPTER THEO LEVEL (SẮP XẾP THEO TITLE CỦA CHAPTER)                 */
/* ------------------------------------------------------------------ */
/**
 * Lấy danh sách chapter của một level, sort theo title A→Z.
 * @param {string} levelId
 * @returns {Array<{id:string, title:string, exercises:Array}>}
 */
export const getChaptersByLevel = (levelId) => {
  const levelData = mockData[levelId];
  if (!levelData) return [];

  const entries = Object.entries(levelData.chapters || {});
  return entries
    .map(([id, chap]) => ({ id, ...chap }))
    .sort((a, b) => {
      const byTitle = cmp(a.title, b.title);
      return byTitle !== 0 ? byTitle : cmp(a.id, b.id);
    });
};

/* ------------------------------------------------------------------ */
/* EXERCISE THEO CHAPTER (SẮP XẾP THEO TITLE)                          */
/* ------------------------------------------------------------------ */
/**
 * Lấy danh sách bài tập trong một chapter, sort theo title A→Z.
 * @param {string} levelId
 * @param {string} chapterId
 */
export const getExercisesByChapter = (levelId, chapterId) => {
  const levelData = mockData[levelId];
  if (!levelData || !levelData.chapters?.[chapterId]) return [];
  const list = levelData.chapters[chapterId].exercises || [];
  // sắp xếp theo title; fallback theo id
  return [...list].sort((a, b) => {
    const byTitle = cmp(a.title, b.title);
    return byTitle !== 0 ? byTitle : cmp(a.id, b.id);
    // nếu bạn muốn sort theo id thay vì title: return cmp(a.id, b.id);
  });
};

/* ------------------------------------------------------------------ */
/* TRA CỨU CHI TIẾT BÀI TẬP                                           */
/* ------------------------------------------------------------------ */
export const getExerciseDetailsById = (exerciseId) => {
  return allExercises[exerciseId] || null;
};

/* ------------------------------------------------------------------ */
/* LẤY PROGRESS TỪ FIRESTORE                                          */
/* ------------------------------------------------------------------ */
/**
 * Lấy tiến độ cho 1 chapter từ Firestore.
 * @param {string} levelId
 * @param {string} chapterId
 * @returns {Promise<Array>}
 */
export const getProgressForChapter = async (levelId, chapterId) => {
  try {
    const progressRef = collection(db, "progress");
    const q = query(
      progressRef,
      where("levelId", "==", levelId),
      where("chapterId", "==", chapterId)
    );
    const snap = await getDocs(q);
    return snap.docs.map((d) => d.data());
  } catch (error) {
    console.error("Error fetching progress for chapter:", error);
    return [];
  }
};
